import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import { HiArrowNarrowRight } from 'react-icons/hi'
import { Link } from 'react-scroll'

const Contact = () => {
  const [message, setMessage] = useState(null);

  const handleSubmit = (event) => {
    event.preventDefault();

    const formData = new FormData(event.target);
    const name = formData.get('name');
    const email = formData.get('email');
    const messageContent = formData.get('message');

    // Check if any field is empty
    if (!name || !email || !messageContent) {
      setMessage({ type: 'error', content: 'Please fill in all fields.' });
      return;
    }

    // Proceed with sending the email
    const serviceId = process.env.REACT_APP_SERVICE_ID;
    const templateId = process.env.REACT_APP_TEMPLATE;
    const userId = process.env.REACT_APP_USER_ID;

    emailjs.send(serviceId, templateId, {
      from_name: name,
      from_email: email,
      message: messageContent,
    }, userId)
      .then((response) => {
        setMessage({ type: 'success', content: 'Email sent successfully!' });
        console.log('Email sent successfully:', response);
      })
      .catch((error) => {
        setMessage({ type: 'error', content: 'Failed to send email. Please try again later.' });
        console.error('Error sending email:', error);
      });
  };

  return (
    <div name='contact' className='w-full h-screen py-20 bg-[#0a192f] flex justify-center items-center p-4'>
      <form onSubmit={handleSubmit} className='flex flex-col max-w-[600px] w-full'>
        <div className='pb-18 pt-16 flex space-x-10 items-center'>
          <p className='text-4xl font-bold inline border-b-4 border-pink-600 text-gray-300'>Contact</p>
          <Link to="footer" smooth={true} duration={500}>
            <button className='text-white group border-2 hover:bg-pink-600 hover:border-pink-600 px-3 py-2 mx-3 my-2 flex items-center' type="button">
              More details
              <span className='group-hover:rotate-90 duration-300'>
                <HiArrowNarrowRight className='ml-3'/>
              </span>
            </button>
          </Link>
        </div>

        <p className='text-gray-300 py-4'>
          // Submit the form below or shoot me an email at varadpk20@gmail.com
        </p>

        <input className='bg-[#ccd6f6] p-2' type="text" placeholder='Name' name='name' />
        <input className='my-4 p-2 bg-[#ccd6f6]' type="email" placeholder='Email' name='email' />
        <textarea className='bg-[#ccd6f6] p-2' name="message" rows="10" placeholder='Message'></textarea>
        <button className='text-white border-2 hover:bg-pink-600 hover:border-pink-600 px-4 py-3 my-8 mx-auto flex items-center' type="submit">Let's Connect</button>

        {message && (
          <div className={`text-lg ${message.type === 'success' ? 'text-green-500' : 'text-red-500'}`}>
            {message.content}
          </div>
        )}
      </form>
      <br />
    </div>
  );
};

export default Contact;
